interface Props {
  recording: boolean;
  /** 0..1 ring fill while recording. */
  progress?: number;
  disabled?: boolean;
  onClick(): void;
  label?: string;
}

export function ShutterButton({ recording, progress = 0, disabled, onClick, label }: Props) {
  const size = 80;
  const ringRadius = size / 2 - 5;
  const circumference = 2 * Math.PI * ringRadius;
  const dash = circumference * Math.min(1, Math.max(0, progress));

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label ?? (recording ? 'Stop recording' : 'Capture')}
      style={{
        position: 'relative',
        width: size,
        height: size,
        borderRadius: '50%',
        border: 'none',
        padding: 0,
        background: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={ringRadius}
          fill="rgba(0,0,0,0.4)"
          stroke="rgba(255,255,255,0.85)"
          strokeWidth={4}
        />
        {recording && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={ringRadius}
            fill="none"
            stroke="var(--accent)"
            strokeWidth={4}
            strokeDasharray={`${dash} ${circumference}`}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            strokeLinecap="round"
          />
        )}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={recording ? 16 : 28}
          rx={recording ? 6 : undefined}
          fill={recording ? '#ff2f6a' : '#ffffff'}
          style={{ transition: 'r 200ms ease' }}
        />
      </svg>
    </button>
  );
}
